// extracted by mini-css-extract-plugin
export default {"container":"Jo-z","bubbleNav":"Ko-z","graphic":"Lo-z","contact":"Mo-z"};